module.exports = __webpack_public_path__ + "static/media/vegitables_35.84733283.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_35.csv
// module id = 619
// module chunks = 0